
import React from 'react';
import { useTranslation } from '@/contexts/translation';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from '../ui/button';
import { Loader2, Globe } from 'lucide-react';

interface LanguageSelectorProps {
  className?: string;
  iconColor?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ 
  className = '', 
  iconColor = 'currentColor' 
}) => {
  const { language, setLanguage, languageOptions, isTranslating } = useTranslation();
  
  const currentLanguage = languageOptions.find(option => option.code === language);
  
  return (
    <Select value={language} onValueChange={(value) => setLanguage(value as any)}>
      <SelectTrigger className={`w-auto bg-transparent border-0 ${className}`}>
        <Button variant="ghost" size="icon" className={className}>
          <span className="flex items-center">
            {isTranslating ? (
              <Loader2 className="h-4 w-4 animate-spin mr-1" />
            ) : (
              <span className="text-lg mr-1">{currentLanguage?.flag || <Globe size={16} />}</span>
            )}
            <span className="hidden md:inline text-xs">{currentLanguage?.code.toUpperCase()}</span>
          </span>
        </Button>
      </SelectTrigger>
      <SelectContent align="end" className="bg-white z-[9999]">
        {languageOptions.map((option) => (
          <SelectItem 
            key={option.code} 
            value={option.code}
            className="cursor-pointer"
          >
            <div className="flex items-center">
              <span className="mr-2 text-lg">{option.flag}</span>
              <span>{option.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
